import React, { useState } from "react";
import { Link } from "react-router-dom";
import FirebaseAuthService from "../../firebase/FirebaseAuthService";
import { toast } from "react-toastify";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");
        try {
            await FirebaseAuthService.forgotPassword(
                email
            );
   toast.success(
        "Si cette adresse email existe, un lien de réinitialisation a été envoyé."
    );
        } catch(error){
    switch(error.code){
        case "auth/invalid-email":
            setErrorMessage("Adresse email invalide.");
            break;
        default:
            setErrorMessage(error.message);
    }
}
        setLoading(false);

    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-5">
                    <div className="card shadow">
                        <div className="card-body">
                            <h3 className="text-center mb-4">
                                Mot de passe oublié
                            </h3>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label>
                                        Adresse Email
                                    </label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(
                                                e.target.value
                                            )
                                        }
                                        required
                                    />
                                </div>
                                {errorMessage && (
                                    <div className="alert alert-danger">
                                        {errorMessage}
                                    </div>
                                )}
                                <button
                                    className="btn btn-success w-100"
                                    disabled={loading}
                                >
                                    {loading
                                        ? "Envoi..."
                                        : "Envoyer le lien"}

                                </button>

                            </form>

                            <div className="text-center mt-3">

                                <Link to="/login">

                                    Retour à la connexion

                                </Link>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}